// extracted by mini-css-extract-plugin
export default {"Button":"P4OHzSMEF7M02BRLK3gS"};